import { useTranslation } from '@mc/i18n'
import { paths } from '@mc/paths'
import Link from 'components/Link'
import { TrackClick } from 'pages/certificates/tracking'

export const LoginLink = ({ className = '' }: { className?: string }) => {
  const { t } = useTranslation('@mc/next')

  return (
    <TrackClick event='certificateNavigationClicked' level='primary'>
      <Link href={paths.logIn(paths.certificates)} className={className}>
        {t('nav.cta.login')}
      </Link>
    </TrackClick>
  )
}
